import {
    backArticleReplyApi,
    backDetailApi,
    backReplyApi,
    queryArticleEvaluationPageApi
} from "@/api/lxh/applet/evaluation";
import {queryAllArticleApi} from "@/api/lxh/applet/article";

export const mixins = {
    components:{
    },
    data(){
        return{
            articleListDialogShow:false,
            viewDialogShow:false,
            modeType:1,
            options:[],
            params:{
                articleUuid:"",
                current:1,
                size:10,
            },
            rows:[],
            total:0,
            detailInfo:{
                content:"aaaaaaaaa",
                replyContent:"bbbbbbb",
                fileList:[{
                    fullUrl:"",
                    name:""
                }]
            }
        }
    },

    methods:{
        handleSizeChange(val) {
            this.params.size = val
            this.getList()
        },
        handleCurrentChange(val) {
            this.params.current = val
            this.getList()
        },
        async getList(){
            let {data}  = await queryArticleEvaluationPageApi(this.params)
            this.rows = data.rows
            this.total = data.total
        },
        init(articleUuid){
            this.articleListDialogShow = true
            if(articleUuid){
                this.params.articleUuid = articleUuid
            }
            this.getList()
            this.queryAllArticle()
        },
        search(){
            this.params.current=1
            this.getList()
        },
        async queryAllArticle(){
            let {data} =  await queryAllArticleApi()
            this.options=data
        },
        resetSearch(){
            this.params.comboId = ''
            this.search()
        },
        async viewThis(item){

            let {data} = await backDetailApi({uuid:item.uuid})
            this.detailInfo = data
            this.modeType = 1
            this.viewDialogShow = true
        },
        async replyThis(item){
            // let {data} = await backDetailApi({uuid:item.uuid})
            this.detailInfo = {
                uuid:item.uuid,
                content:item.content,
                replyContent:"",
                fileList:item.fileList
            }
            this.viewDialogShow = true
            this.modeType = 2

        },

        async replySubmit(){
            let param = {
                uuid:this.detailInfo.uuid,
                replyContent:this.detailInfo.replyContent
            }
            console.log(param)
            let res  = await backArticleReplyApi(param)
            if(res.code === 200){
                this.$message({
                    type: 'success',
                    message: '回复成功!'
                });
                this.viewDialogShow = false
                this.getList()
            }else{
                this.$message({
                    type: 'error',
                    message: res.msg
                });
            }
        }

    },
    created() {
        //this.init()
    }
}
